import { EVChargerOutput, EVChargerStatus, EVChargerOutputStatus, EVChargerOutputPort, EVChargerOutputPortStatus, EVChargerOutputType } from '@/entity/station/evcharger';
import { ValueRange } from '@/entity/value-range';
import { EVChargerOutputPortTransformer } from "../transformers/evcharger-ouput-port";


export class EVChargerOutputTransformer {
    transform(outputInfo: any) : EVChargerOutput {
        let ports: EVChargerOutputPort[] = []
        let portsInfos: any[] = outputInfo.ports
        if(portsInfos && portsInfos.length) {
            portsInfos.forEach(portInfo => {
                ports.push(new EVChargerOutputPortTransformer().transform(portInfo))
            });
        }
        let output = new EVChargerOutput(
            outputInfo.outputId,
            outputInfo.outputNumber,
            //below code is commented by vinoth on 29.04.2021 for tagNo is optional as per new requirements
            // outputInfo.tagNo,
            new EVChargerOutputType(
                "",
                "",
                outputInfo.outputVolt,
                outputInfo.outputPhase,
                new ValueRange(outputInfo.outputKWStart, outputInfo.outputKWEnd),
                new ValueRange(outputInfo.outputCurrentStart, outputInfo.outputCurrentEnd),
                [],
                outputInfo.outputType
            ),
            ports,
            outputInfo.qrcode 
        )
        if(outputInfo.status) {            
            output.status = new EVChargerOutputStatus(outputInfo.status.code, outputInfo.status.description)
        }
        return output
    }

    deTransform(output: EVChargerOutput) : any {
        let ports = output.ports
        let portsInfos: any[] = []
        ports.forEach(port => {
            let portInfo = new EVChargerOutputPortTransformer().deTransform(port)
            portInfo = {
                ...portInfo,
                outputId: output.id
            }
            portsInfos.push(portInfo)
        });
        let outputInfo: any =  {
            outputId: output.id,
            outputNumber: output.number,
            //below code is commented by vinoth on 29.04.2021 for tagNo is optional as per new requirements
            // tagNo: output.tag,
            outputVolt: output.type.volt,
            outputPhase: output.type.phase,
            outputKWStart: output.type.kwRange.start,
            outputKWEnd: output.type.kwRange.end,
            outputCurrentStart: output.type.currentRange.start,
            outputCurrentEnd: output.type.currentRange.end,
            ports: portsInfos,
            noOfChargingPorts: ports.length,
            outputType: output.type.outputType
        }
        if(output.status) {
            outputInfo = {
                ...outputInfo,
                rowStatus: {
                    code: output.status.id
                }
            }
        }
        return outputInfo
    }
}